<script lang="ts" setup>
import { getCanonicalUrl } from '~/helpers'
import CatalogPageProvider from '~/layers/catalog/components/CatalogPageProvider.vue'
import { useCatalogStore } from '~/layers/catalog/store/catalog'

defineOptions({
  name: 'JewelryCatalogPage',
})

const store = useCatalogStore()
const route = useRoute()
const { setMetaFields } = usePageMeta()
const selectedCategories = computed(() => store.selectedCategories)
const categoriesUrl = computed(() => selectedCategories.value.join('_or_'))
const canonicalUrl = computed<string>(() =>
  getCanonicalUrl(`/jewelry/${selectedCategories.value.length ? `${categoriesUrl.value}/` : ''}`),
)

watch(
  [canonicalUrl, () => route.path],
  () =>
    setMetaFields({
      canonical: canonicalUrl.value,
    }),
  { immediate: true },
)
</script>

<template>
  <CatalogPageProvider key="jewelry-filter" type="jewelry" />
  <!-- для корректной отрисовки роута(потом при рефакторинге удалить) -->
  <NuxtPage />
</template>
